// SubTaskForm

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import FieldTitle from '../../form/field_title/field_title.jsx'
import FieldText from '../../form/field_text/field_text.jsx'
import FieldDate from '../../form/field_date/field_date.jsx'
import FieldTextarea from '../../form/field_textarea/field_textarea.jsx'
import FieldActions from '../../form/field_actions/field_actions.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'

class SubTaskForm extends Component {
  static get propTypes () {
    return {
      subtask: PropTypes.object,
      onChange: PropTypes.func,
      onSave: PropTypes.func,
      onReopen: PropTypes.func,
      onComplete: PropTypes.func,
      onDelete: PropTypes.func,
      autoFocusTitle: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      subtask: null,
      onChange: null,
      onSave: null,
      onReopen: null,
      onComplete: null,
      onDelete: null,
      autoFocusTitle: false
    }
  }

  render () {
    const {
      subtask,
      autoFocusTitle,
      onReopen,
      onComplete,
      onDelete
    } = this.props

    return (
      <div className='subtaskform'>
        <FieldTitle title='plannerv2.subtask.editTitle' />
        <FieldText
          name='title'
          value={subtask.title}
          showEdit={false}
          autoFocus={autoFocusTitle}
          validations={['required']}
          onChange={this._onChangeInput.bind(this, 'title')}
          onSave={this._onSaveInput.bind(this, 'title')}
        />
        <FieldActions>
          {subtask.completed ? (
            <IconButton
              icon='done'
              type='success'
              label='plannerv2.task.doneTask'
              className='actioncomplete'
              canHover
              onClick={(ev) => (onReopen ? onReopen(subtask, ev) : null)}
            />
          ) : (
            <IconButton
              icon='done'
              type='disabled'
              label='plannerv2.task.doneTask'
              className='actioncomplete'
              canHover
              onClick={(ev) => (onComplete ? onComplete(subtask, ev) : null)}
            />
          )}
          <IconButton
            icon='x'
            type='error'
            label='plannerv2.task.deleteSubTask'
            alignLabel='right'
            className='actiondelete'
            onClick={(ev) => (onDelete ? onDelete(subtask, ev) : null)}
          />
        </FieldActions>
        <FieldTitle title='plannerv2.subtask.editDescription' />
        <FieldTextarea
          name='description'
          value={subtask.description}
          showEdit={false}
          placeholder='plannerv2.subtask.editPlaceholderDescription'
          onChange={this._onChangeInput.bind(this, 'description')}
          onSave={this._onSaveInput.bind(this, 'description')}
        />
        <FieldTitle title='plannerv2.subtask.editDueDate' />
        <FieldDate
          name='dueDate'
          startDate={subtask.dueDate}
          isSingleDate
          onChange={this._onChangeDate.bind(this, 'dueDate')}
        />
      </div>
    )
  }

  /* Event handlers */
  _onChangeInput (name, value, ev) {
    if (this.props.onChange) {
      this.props.onChange(this.props.subtask, name, value, ev)
    }
  }

  _onChangeDate (name, value, ev) {
    if (this.props.onChange) {
      this.props.onChange(this.props.subtask, name, value, ev)
    }

    this._onSaveInput(name)
  }

  _onSaveInput (name) {
    const { subtask, onSave } = this.props
    const isValid = (name === 'title' && subtask[name]) || true

    if (onSave && isValid) {
      onSave(subtask, name)
    }
  }
}

export default SubTaskForm
